module.exports = __webpack_public_path__ + "static/img/012.820f380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/012.png
// module id = yP85
// module chunks = 1